import Cropper from 'cropperjs';
import 'cropperjs/dist/cropper.css'
export default function() {
    let $avatar = document.querySelector('.avatar-img');
    let $image = document.querySelector('.crop-img');
    let $input = document.querySelector('.avatar-input');
    let $modal = document.querySelector('.crop-modal')
    let $modalPending = document.querySelector('.modal-pending ');

    let cropper;

    if(!$input) return false;

    $input.addEventListener('change', function (e) {
        let files = e.target.files;
        let done = function (url) {
            $input.value = '';
            $image.src = url;
            $modal.style.display = "block"
            cropper = new Cropper($image, {
                aspectRatio: 1,
                viewMode: 3,
                checkOrientation: false
            });
        };

        let reader;
        let file;

        if (files && files.length > 0) {
            file = files[0];

            if (URL) {
                done(URL.createObjectURL(file));
            } else if (FileReader) {
                reader = new FileReader();
                reader.onload = function (e) {
                    done(reader.result);
                };
                reader.readAsDataURL(file);
            }
        }
    });

    document.querySelector('.crop-submit').addEventListener('click', function () {
        let canvas;
        $modalPending.style.display = 'flex';
console.warn($modalPending.style.display);
        if (cropper) {
            console.warn("click");
            canvas = cropper.getCroppedCanvas({
                maxWidth: 1920,
                maxHeight: 1920,
            });
            $avatar.src = canvas.toDataURL("image/jpeg",0.9);

            canvas.toBlob(function (blob) {
                let file = new File([blob], "avatar.jpeg", {type:"image/jpeg", lastModified:new Date().getTime()});
                let container = new DataTransfer();
                console.warn(file);
                container.items.add(file);
                $input.files = container.files;
                $modal.style.display = 'none';
                $modalPending.style.display = 'none';
            });
        }
    });

    document.querySelector('.modal-close').addEventListener('click', function () {
        $modal.style.display = 'none';
    })
}
